import { promocodeInActionMobile } from 'reactApp/appHelpers/featuresHelpers/features/promocodeOnPromoQuota';
import type { DiscountType } from 'reactApp/sections/MobileSubscriptionsPage/Discounts/Components/DiscountCard/DiscountCard.types';

export const DISCOUNTS = {
    trial: 'trial',
    special: 'special',
    promocode: 'promocode',
    autumnPromo: 'autumnPromo',
} as const;

export const ACTIVATE_PROMOCODE_CARD = {
    id: DISCOUNTS.promocode,
    type: DISCOUNTS.promocode,
    title: 'Используйте промокод',
    text: 'Если у вас есть промокод —\n самое время его активировать',
    link: !promocodeInActionMobile ? '/promocodes' : undefined,
};

export const buttonTextMap: Record<DiscountType, string> = {
    special: 'Приобрести',
    trial: 'Подключить',
    promocode: 'Ввести промокод',
    autumnPromo: 'Забрать скидку',
};
